module.exports = __webpack_public_path__ + "static/media/tarot-card-8.0640cfc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-8.jpg
// module id = 148
// module chunks = 0